
import { Component, Prop, Vue, Emit } from "vue-property-decorator";

import { IPostSignMeetingUser } from "@/api/modules/signup/index.dto";

@Component
export default class Confirm extends Vue {
  private flags: any = {
    submit: true,
    loading: false,
  };
  private nextMsg: string = "下一步";
  private singnUpDatas: any[] = [];
  private total: any;
  private vip: string = "";

  @Prop({
    type: Object,
    default: {},
    required: true,
  })
  confirmDatas!: any;

  /**
   * @description: 将票种数据给父组件
   */
  @Emit("handleConfirmInfo")
  handleConfirmInfo(type: string) {
    let ticketData: any;
    ticketData = {
      type,
    };
    return ticketData;
  }

  created() {
    this.vip = this.confirmDatas.is_vip === 0 ? "嘉宾" : "VIP";

    let _singnUpDatas;
    for (let i in this.confirmDatas.UserEntity) {
      let _datas = this.confirmDatas.UserEntity[i].DataEntity;
      // 过滤掉表单没有值的项
      _singnUpDatas = _datas.filter((_item: any) => {
        if (Number(_item.value) != 0) {
          return _item.value;
        }
      });
      this.singnUpDatas.push(_singnUpDatas);
	  
    }
    // console.log("报名信息", this.confirmDatas);
    // console.log("this.singnUpDatas", this.singnUpDatas);

    if (this.confirmDatas.ticket) {
      this.total = (this.confirmDatas.ticket.money * this.confirmDatas.ticket.count).toFixed(2);
    }

    if (!this.confirmDatas.ticket || this.total === 0) {
      this.nextMsg = "提交";
    }
    this.confirmDatas.UserEntity.map((item: any) => {
      for (let i in item.DataEntity) {
        let { value } = item.DataEntity[i];
        if (value instanceof Array === true) {
          item.DataEntity[i].value = value.toString(",");
        }
      }
    });
	console.log('11111111111',this.confirmDatas)
  }

  /**
   * @title 提交报名数据
   */
  handleSubmit(type: string) {
    if (this.flags.submit) {
      this.nextMsg = "请稍后...";
      this.flags.submit = false;
      this.flags.loading = true;
      let { ticket, UserEntity } = this.confirmDatas;
      let { ch, m, channelId } = this.$route.query;

      let singnUpDatas: IPostSignMeetingUser = {
        m: String(m),
        settypeid: ticket ? ticket.settypeid : undefined,
        chid: channelId !== undefined ? Number(channelId) : Number(ch),
        UserEntity,
      };
      if (this.confirmDatas.is_vip !== 3) {
        singnUpDatas.is_vip = this.confirmDatas.is_vip;
      }
	  console.log(singnUpDatas)
      this.handlePost(singnUpDatas, type);
    }
  }
  async handlePost(singnUpDatas: IPostSignMeetingUser, type: string) {
    let res = await this.$http.SignUp.PostSignMeetingUser(singnUpDatas);
    const _params = this.$route.query;
    console.log(res)
    if (res.Code === 1000) {
      this.$router.push({
        path: "/personalCenter",
        query: _params,
      });
    } else if (res.Code === 1010) {
      this.handleConfirmInfo(type);
    }

    this.flags.submit = true;
    this.flags.loading = false;
    this.nextMsg = this.confirmDatas.ticket ? "下一步" : "提交";
  }
}
